import template from './list.html';
import controller from './list.controller';

function routeConfig($stateProvider) {
	'ngInject';

	$stateProvider
		// Using a '.' within a state name declares a child within a parent.
		// So you have a new state 'Cities' within the parent 'app.private' state.
		.state('app.private.lines.list', {
			template,
			controller,
			'url': '/list',
			'controllerAs': 'vm',
			'params': {
				'page': 1
			},
			'resolve': {
				'Lines': function($stateParams, LineComponent) {
					'ngInject';

					return LineComponent.fetchLines($stateParams.page, 0, '-id', 'stations,translation,translations');
				}
			}
		});
}

export default routeConfig;



/** WEBPACK FOOTER **
 ** ./client/private/lines/list/list.route.js
 **/